import { AxiosResponse } from "axios";
import { api } from "./base/api";
import { IUserGroupApi } from "./base/userGroupApi";
import { KeyValue } from "../models/common";
import { Result } from "../models/common/resultResponse";
import { UserGroupFilterRequest } from "../models/request/usergroupRequest";

const baseRoute: string = "Group";

export class UserGroupApi extends IUserGroupApi {
	getDomain(groupFilter: UserGroupFilterRequest): Promise<AxiosResponse<Result<KeyValue[]>>> {
		return api.get(`${baseRoute}/domain`, { params: groupFilter });
	}
}
